const DAY = 24 * 60 * 60 * 1000;

export const daysAgoISO = (days, hours = 10) => {
  const d = new Date(Date.now() - days * DAY);
  d.setHours(hours, 0, 0, 0);
  return d.toISOString();
};
export const daysAheadISO = (days) => {
  const d = new Date(Date.now() + days * DAY);
  d.setHours(23, 59, 0, 0);
  return d.toISOString();
};

export const formatDate = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const relativeDate = (iso) => {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  const days = Math.floor(diff / DAY);
  if (days <= 0) return 'hoje';
  if (days === 1) return 'ontem';
  if (days < 30) return `há ${days} dias`;
  const months = Math.floor(days / 30);
  return months === 1 ? 'há 1 mês' : `há ${months} meses`;
};

export const RECENT_DAYS = 7;
export const isRecent = (iso) => !!iso && Date.now() - new Date(iso).getTime() <= RECENT_DAYS * DAY;
export const isExpired = (iso) => !!iso && new Date(iso).getTime() < Date.now();
export const daysUntil = (iso) => (iso ? Math.ceil((new Date(iso).getTime() - Date.now()) / DAY) : null);

export const initials = (name = '') =>
  name
    .split(/\s+/)
    .filter((w) => w.length > 2 || /^[A-Z]/.test(w))
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase() || '?';

export const normalize = (s = '') =>
  s.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export const uid = (prefix = 'id') => `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;

export const onlyDigits = (s = '') => s.replace(/\D/g, '');

export const formatCnpj = (v = '') => {
  const d = onlyDigits(v).slice(0, 14);
  return d
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};

export const formatPhone = (v = '') => {
  const d = onlyDigits(v).slice(0, 11);
  if (d.length <= 10) return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
  return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
};

/** Hue estável a partir de uma string — usado em avatares e capas geradas. */
export const hueFrom = (s = '') => {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) % 360;
  return 185 + (h % 40); // faixa ciano/azul
};
